import { render } from "./AlertsView.vue?vue&type=template&id=08d7775e&scoped=true"
import script from "./AlertsView.vue?vue&type=script&lang=js"
export * from "./AlertsView.vue?vue&type=script&lang=js"

import "./AlertsView.vue?vue&type=style&index=0&id=08d7775e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d7775e"]])

export default __exports__